/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardsAccountAddPackagePointsRequest
 */
export interface RewardsAccountAddPackagePointsRequest {
    /**
     * 
     * @type {string}
     * @memberof RewardsAccountAddPackagePointsRequest
     */
    courierId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardsAccountAddPackagePointsRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardsAccountAddPackagePointsRequest
     */
    packageId?: string;
}

/**
 * Check if a given object implements the RewardsAccountAddPackagePointsRequest interface.
 */
export function instanceOfRewardsAccountAddPackagePointsRequest(value: object): value is RewardsAccountAddPackagePointsRequest {
    return true;
}

export function RewardsAccountAddPackagePointsRequestFromJSON(json: any): RewardsAccountAddPackagePointsRequest {
    return RewardsAccountAddPackagePointsRequestFromJSONTyped(json, false);
}

export function RewardsAccountAddPackagePointsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardsAccountAddPackagePointsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'packageId': json['packageId'] == null ? undefined : json['packageId'],
    };
}

export function RewardsAccountAddPackagePointsRequestToJSON(json: any): RewardsAccountAddPackagePointsRequest {
    return RewardsAccountAddPackagePointsRequestToJSONTyped(json, false);
}

export function RewardsAccountAddPackagePointsRequestToJSONTyped(value?: RewardsAccountAddPackagePointsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'userId': value['userId'],
        'packageId': value['packageId'],
    };
}

